import _defineProperty from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { useState, Fragment, useEffect, useRef } from 'react';
import styled from 'styled-components';
import styles from './HeaderV2.style';
import _Logo from './Areas/Logo';
import _MainMenu from './Areas/MainMenu';
import _HamburgerButton from './Areas/HamburgerButton';
import _CTAMenu from './Areas/CTAMenu';
import _MiniCTAMenu from './Areas/MiniCTAMenu';
import _UtilityMenu from './Areas/UtilityMenu';
import _ContactInformation from './Areas/ContactInformation';
import _SocialMedia from './Areas/SocialMedia';
import Mailchimp from '../../atoms/Mailchimp';
import { HEADER_PARENTS } from '../../../constants/globalConstants';
import SearchArea from './Areas/SearchArea';
import cn from 'classnames';
import HeaderStateProvider from './HeaderStateProvider';
import useMediaQuery from '../../../hooks/useMediaQuery';
import { HEADER_VAR } from './HeaderV2.variables';
var componentsMap = {
  'Logo': function Logo(props) {
    return __jsx(_Logo, {
      headerLogo: props.headerLogo
    });
  },
  'Hamburger Button': function HamburgerButton(props) {
    return __jsx(_HamburgerButton, {
      isMobileMenuOpen: props.isMobileMenuOpen,
      handleMobileMenuToggle: props.handleMobileMenuToggle
    });
  },
  'CTA Menu': function CTAMenu(props) {
    return __jsx(_CTAMenu, {
      ctaMenuCollection: props.header.ctaMenuCollection,
      parent: props.parent,
      openDropdownOnClick: props.header.openDropdownsOnClick
    });
  },
  'Mini CTA Menu': function MiniCTAMenu(props) {
    return __jsx(_MiniCTAMenu, {
      miniCtaMenuItems: props.header.miniCtaMenuCollection.items,
      yextContactInformationData: props.yextContactInformationData
    });
  },
  'Main Menu': function MainMenu(props) {
    return __jsx(_MainMenu, {
      mainMenuCollection: props.header.mainMenuCollection,
      openDropdownOnClick: props.header.openDropdownsOnClick
    });
  },
  'Utility Menu': function UtilityMenu(props) {
    return __jsx(_UtilityMenu, {
      items: props.header.utilityMenuCollection.items
    });
  },
  'Contact Information': function ContactInformation(props) {
    return __jsx(_ContactInformation, {
      items: props.header.contactInformationCollection.items,
      yextContactInformationData: props.yextContactInformationData,
      openDropdownOnClick: props.header.openDropdownsOnClick
    });
  },
  'Social Media': function SocialMedia(props) {
    return __jsx(_SocialMedia, {
      socialMedia: props.header.socialMedia,
      siteName: props.siteName
    });
  },
  'Search': function Search() {
    return __jsx(SearchArea, null);
  },
  'Divider': function Divider() {
    return __jsx("span", {
      className: "nva-header__divider"
    });
  }
};
var HeaderItem = function HeaderItem(props) {
  var _componentsMap$props$;
  return (_componentsMap$props$ = componentsMap[props.component]) === null || _componentsMap$props$ === void 0 ? void 0 : _componentsMap$props$.call(componentsMap, props);
};
var Grid = function Grid(_ref) {
  var logicalOrder = _ref.logicalOrder,
    parent = _ref.parent,
    header = _ref.header,
    headerLogo = _ref.headerLogo,
    siteName = _ref.siteName,
    yextData = _ref.yextData,
    handleMobileMenuToggle = _ref.handleMobileMenuToggle,
    isMobileMenuOpen = _ref.isMobileMenuOpen;
  return logicalOrder === null || logicalOrder === void 0 ? void 0 : logicalOrder.map(function (component, index) {
    return __jsx(Fragment, {
      key: component.area + index
    }, __jsx(HeaderItem, {
      component: component.area,
      parent: parent,
      header: header,
      yextContactInformationData: yextData,
      headerLogo: headerLogo,
      siteName: siteName,
      handleMobileMenuToggle: handleMobileMenuToggle // used on hamburger menu
      ,
      isMobileMenuOpen: isMobileMenuOpen // used on hamburger menu
    }));
  });
};

var HeaderV2 = function HeaderV2(_ref2) {
  var _header$logicalOrderD, _header$logicalOrderD2, _header$logicalOrderM, _header$logicalOrderM2, _header$codeBlocksCol, _header$ctaMenuCollec;
  var className = _ref2.className,
    header = _ref2.header,
    yextContactInformationData = _ref2.yextContactInformationData,
    headerLogo = _ref2.headerLogo,
    siteName = _ref2.siteName;
  var headerRef = useRef(null);
  var _useState = useState(false),
    isMobileMenuOpen = _useState[0],
    setIsMobileMenuOpen = _useState[1];
  var _useState2 = useState(''),
    mobileMenuClass = _useState2[0],
    setMobileMenuClass = _useState2[1];
  var isXs = useMediaQuery('xs');
  var isSm = useMediaQuery('sm');
  var isMd = useMediaQuery('md');
  var isLg = useMediaQuery('lg');
  var isXl = useMediaQuery('xl');
  var is2xl = useMediaQuery('2xl');
  var is3xl = useMediaQuery('3xl');
  var logicalOrderDesktop = header === null || header === void 0 ? void 0 : (_header$logicalOrderD = header.logicalOrderDesktop) === null || _header$logicalOrderD === void 0 ? void 0 : (_header$logicalOrderD2 = _header$logicalOrderD.areasCollection) === null || _header$logicalOrderD2 === void 0 ? void 0 : _header$logicalOrderD2.items;
  var logicalOrderMobile = header === null || header === void 0 ? void 0 : (_header$logicalOrderM = header.logicalOrderMobile) === null || _header$logicalOrderM === void 0 ? void 0 : (_header$logicalOrderM2 = _header$logicalOrderM.areasCollection) === null || _header$logicalOrderM2 === void 0 ? void 0 : _header$logicalOrderM2.items;
  var forceStickyPrimaryCtaRender = header.stickyPrimaryCta && !(logicalOrderMobile !== null && logicalOrderMobile !== void 0 && logicalOrderMobile.some(function (item) {
    return item.area === 'CTA Menu';
  }));
  var codeBlocks = (_header$codeBlocksCol = header.codeBlocksCollection) === null || _header$codeBlocksCol === void 0 ? void 0 : _header$codeBlocksCol.items;
  var handleMobileMenuToggle = function handleMobileMenuToggle() {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    setMobileMenuClass(isMobileMenuOpen ? 'is-closing' : 'is-open');
  };
  var handleMobileMenuTransitionEnd = function handleMobileMenuTransitionEnd() {
    if (!isMobileMenuOpen) {
      setMobileMenuClass('');
    }
  };
  useEffect(function () {
    if (!headerRef.current) return;
    document.documentElement.style.setProperty(HEADER_VAR.height["public"], "".concat(headerRef.current.offsetHeight, "px"));
  }, [isXs, isSm, isMd, isLg, isXl, is2xl, is3xl]);
  return __jsx(HeaderStateProvider, {
    initialData: {
      handleMobileMenuToggle: handleMobileMenuToggle
    }
  }, __jsx("header", {
    ref: headerRef,
    className: cn("nva-header", {
      'nva-header--overlay': header.enableHeaderOverlay
    }, className)
  }, __jsx("div", {
    className: "nva-header__wrapper--desktop"
  }, __jsx("div", {
    className: "l-grid nva-header__grid"
  }, __jsx(Grid, {
    logicalOrder: logicalOrderDesktop,
    parent: HEADER_PARENTS.DESKTOP_GRID,
    header: header,
    headerLogo: headerLogo,
    siteName: siteName,
    yextData: yextContactInformationData
  }))), __jsx("div", {
    className: "nva-header__wrapper--mobile ".concat(header.stickyPrimaryCta ? 'has-sticky-cta' : '')
  }, __jsx("div", {
    className: "l-grid nva-header__grid"
  }, __jsx(Grid, {
    logicalOrder: logicalOrderMobile,
    parent: HEADER_PARENTS.MOBILE_GRID,
    header: header,
    headerLogo: headerLogo,
    siteName: siteName,
    yextData: yextContactInformationData,
    handleMobileMenuToggle: handleMobileMenuToggle,
    isMobileMenuOpen: isMobileMenuOpen
  }), forceStickyPrimaryCtaRender && __jsx(_CTAMenu, {
    ctaMenuCollection: {
      items: [_objectSpread({}, (_header$ctaMenuCollec = header.ctaMenuCollection.items) === null || _header$ctaMenuCollec === void 0 ? void 0 : _header$ctaMenuCollec[0])]
    },
    openDropdownOnClick: header.openDropdownsOnClick
  })), __jsx("div", {
    className: "nva-header__mobile-menu ".concat(mobileMenuClass),
    onTransitionEnd: handleMobileMenuTransitionEnd
  }, __jsx("div", {
    className: "l-grid nva-header__mobile-menu-top"
  }, __jsx(Grid, {
    logicalOrder: logicalOrderMobile.filter(function (component) {
      return component.area === 'Hamburger Button' || component.area === 'Logo';
    }),
    parent: HEADER_PARENTS.MOBILE_MENU_TOP,
    header: header,
    headerLogo: headerLogo,
    siteName: siteName,
    yextData: yextContactInformationData,
    handleMobileMenuToggle: handleMobileMenuToggle,
    isMobileMenuOpen: true
  })), __jsx("div", {
    className: "nva-header__mobile-menu-inner"
  }, __jsx("div", {
    className: "l-grid nva-header__mobile-menu-grid"
  }, logicalOrderMobile === null || logicalOrderMobile === void 0 ? void 0 : logicalOrderMobile.map(function (component, index) {
    var _component$areasColle;
    return __jsx(Fragment, {
      key: index
    }, __jsx(Grid, {
      logicalOrder: (_component$areasColle = component.areasCollection) === null || _component$areasColle === void 0 ? void 0 : _component$areasColle.items,
      parent: HEADER_PARENTS.MOBILE_MENU_GRID,
      header: header,
      headerLogo: headerLogo,
      siteName: siteName,
      yextData: yextContactInformationData
    }));
  }))))), codeBlocks === null || codeBlocks === void 0 ? void 0 : codeBlocks.map(function (codeBlock, i) {
    return __jsx("div", {
      className: "codeBlock",
      key: i
    }, __jsx(Mailchimp, {
      mailchimpdata: codeBlock
    }));
  })));
};
export default styled( /*#__PURE__*/React.memo(HeaderV2)).withConfig({
  componentId: "sc-1d58z3o-0"
})(["", ";"], styles);